import { AxiosError } from 'axios';
import { Mutex } from 'async-mutex';
import { TokensStore } from '../stores/tokens.store';
import { AuthClient } from '~/app-modules/auth/clients/auth.client';

@singleton()
export class AuthService {
  constructor(
    protected tokensStore: TokensStore,
    protected authClient: AuthClient,
  ) {}

  private _mutex = new Mutex();

  get Bearer(): string {
    return this.tokensStore.accessToken;
  }

  get isLoggedIn(): boolean {
    return this.tokensStore.tokens !== null;
  }

  getSignInUrl() {
    return this.authClient.getSignInUrl();
  }

  async signIn(code: string) {
    try {
      if (this.isLoggedIn) {
        this.logout();
      }
      const tokensPair = await this.authClient.signIn({ code });
      this.tokensStore.setTokens(tokensPair);
    } catch (error) {
      if (error instanceof AxiosError) {
        // TODO: уточнить ошибки
        if (error.response?.status === 400) {
          useToast().error('Авторизация через SSO недоступна');
          throw error;
        } else {
          console.log(error);
          throw error;
        }
      } else {
        throw error;
      }
    }
  }

  async ensureTokensRefreshed() {
    try {
      await this._mutex.runExclusive(async () => {
        const tokensPair = await this.authClient.refreshToken({
          refreshToken: this.tokensStore.refreshToken,
        });
        this.tokensStore.setTokens(tokensPair);
      });
    } catch (error) {
      console.error(error);
      this.logout();
      useNuxtApp().$router.push('/auth/');
    }
  }

  logout() {
    this.tokensStore.dropTokens();
  }
}
